import { Box, Typography } from '@mui/material';

const Footer = () => (
    <Box
        component="footer"
        sx={{
            flexShrink: 0,
            py: 1.25,
            px: 2,
            textAlign: 'center'
        }}
    >
        <Typography variant="caption" color="text.secondary">
            <strong>The Fastest-Growing Discharge Support Platform</strong>
            {' | Reducing LOS, readmissions, and case manager burnout'}
        </Typography>
    </Box>
);

export default Footer;
